import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import React, { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { images } from "../../config/images";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
const Ultrasonic = ({
  value,
  data,
  page,
  setPage,
  setRowsPerPage,
  rowsPerPage,
  count,
  searchText,
  setSearchText,
  handleSearchData,
}) => {
  const [ultrasonicPopup, setUltrasonicPopup] = useState(false);
  const [ultasonicPopupData, setUltasonicPopupData] = useState({});
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleViewIcon = (e) => {
    setUltasonicPopupData(e);
    setUltrasonicPopup(true);
  };

  return (
    <>
      <div>
        <div className="table-responsive">
          <Table
            aria-label="Dipping parameter"
            className="dipping-parameter-table  washing-table"
          >
            <TableHead>
              <TableRow>
                <TableCell>RFID Tag</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Time</TableCell>
                <TableCell>Shift</TableCell>
                <TableCell>Ultrasonic Tank Time</TableCell>
                <TableCell>Rinsing Tank Time</TableCell>
                <TableCell>Oven Tank Time</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="RFID Tag"
                    name="Rfid"
                    value={searchText?.Rfid}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input type="search" placeholder="Date" name="date"   value={searchText?.date}
                      onChange={handleSearchData}/>
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input type="search" placeholder="Time" name="time"   value={searchText?.time}
                      onChange={handleSearchData}/>
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input type="search" placeholder="Shift" name="shift" value={searchText?.shift}
                      onChange={handleSearchData}/>
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="UltraSonic Tank Time"
                    name="ultraSonicTank"
                    value={searchText?.ultraSonicTank}
                      onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Rinsing Tank Time"
                    name="rinsingTank"
                    value={searchText?.rinsingTank}
                      onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Oven Tank Time"
                    name="OvenTankTime"
                    value={searchText?.OvenTankTime}
                      onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((e) => {
                return (
                  <>
                    <TableRow>
                      <TableCell>{e.rfid_tag}</TableCell>
                      <TableCell>
                        {e.created_at
                          ? dayjs(e.created_at).format("YYYY-MM-DD")
                          : ""}
                      </TableCell>
                      <TableCell>
                        {e.created_at
                          ? dayjs(e.created_at).format("HH:mm")
                          : ""}
                      </TableCell>
                      <TableCell>{e.shift_name}</TableCell>
                      <TableCell>{e.ultrasonic_t_time}</TableCell>
                      <TableCell>{e.rinsing_t_time}</TableCell>
                      <TableCell>{e.oven_tank_time}</TableCell>

                      <TableCell>
                        <img
                          src={images.viewIcon}
                          alt=""
                          onClick={() => handleViewIcon(e)}
                          style={{ cursor: "pointer" }}
                        />
                      </TableCell>
                    </TableRow>
                  </>
                );
              })}
            </TableBody>
          </Table>
          <TablePagination
            className="table-pagination"
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={count ? count : ""}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
      {ultrasonicPopup && (
        <>
          <div
            className="modal-container"
            style={{ height: "40vh", top: "35vh" }}
          >
            <div className="modal-header">
              <div className="modal-title">ULTRASONIC PROCESS SHEET</div>
              <div
                onClick={() => setUltrasonicPopup(false)}
                style={{ cursor: "pointer" }}
              >
                <CloseIcon />
              </div>
            </div>
            <div className="modal-table-wrapper">
              <div
                style={{
                  width: "100%",
                  overflow: "auto",
                  maxHeight: "400px",
                }}
                className="gloves-report-data"
              >
                <div className="d-flex justify-content-between p-4">
                  <div>RFID Tag :{ultasonicPopupData?.rfid_tag}</div>
                  <div>Batch No : {ultasonicPopupData.batch_type}</div>
                </div>
                <Table className="gloves-params">
                  <TableHead>
                    <TableRow>
                      <TableCell colSpan={2}>Ultrasonic Tank Temp </TableCell>
                      <TableCell colSpan={2}>Rinsing Tank Temp</TableCell>
                      <TableCell colSpan={2}>Hot Air Dryer Temp </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Set Temp</TableCell>
                      <TableCell>Actual Temp </TableCell>
                      <TableCell>Set Temp</TableCell>
                      <TableCell>Actual Temp</TableCell>
                      <TableCell>Set Temp</TableCell>
                      <TableCell>Actual Temp </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>
                        {ultasonicPopupData?.ultrasonic_t_set_temp || "--"}
                      </TableCell>
                      <TableCell>
                        {ultasonicPopupData?.ultrasonic_t_act_temp || "--"}
                      </TableCell>
                      <TableCell>
                        {ultasonicPopupData?.rinsing_t_set_temp || "--"}
                      </TableCell>
                      <TableCell>
                        {ultasonicPopupData?.rinsing_t_act_temp || "--"}
                      </TableCell>

                      <TableCell>
                        {ultasonicPopupData?.h_air_dryr_t_set_temp || "--"}
                      </TableCell>
                      <TableCell>
                        {ultasonicPopupData?.h_air_dryr_t_act_temp || "--"}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </div>
            </div>
          </div>
          <div
            className="modal-overlay"
            onClick={() => setUltrasonicPopup(false)}
          ></div>
        </>
      )}
    </>
  );
};

export default Ultrasonic;
